var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Minus = function SvgAv5Minus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4h6",
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })));
};
export { SvgAv5Minus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGgKICAgICAgICBkPSJNMSw0IEg3IgogICAgICAgIHN0cm9rZT0iIzlCOUFDOCIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgLz4KPC9zdmc+Cg==";